import React from 'react';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';

import './TransitionedPage.css';


const TransitionedPage = (WrappedComponent) => {
  const TransitionedComponent = (props) => {
    const newPage = !props.location.hash;
    const transition = (newPage ? 'fade' : 'no-transition');

    return (
      <CSSTransitionGroup
        component="div"
        className="c-transition-group"
        transitionAppear
        transitionAppearTimeout={800}
        transitionEnterTimeout={800}
        transitionLeaveTimeout={400}
        transitionName={transition}
      >
        <WrappedComponent {...props} />
      </CSSTransitionGroup>
    );
  };
  return TransitionedComponent;
};

export default TransitionedPage;



// WEBPACK FOOTER //
// ./src/components/common/transitionedPage/TransitionedPage.jsx